<template>
  <div class="main-bg has-aside-main-bg">
    <page-header title="作业上传" />
    <!-- <page-header title="作业上传" :data="pageHeaderArr" /> -->
    <!-- <el-form v-model="formInline" :inline="true" class="my-schedule-table">
      <el-form-item label="学年" prop="schoolYear">
        <el-select v-model="formInline.schoolYear" clearable placeholder="请选择学年" @change="yearChangeSelect" @clear="yearClearChange()">
          <el-option v-for="item in schoolYearLists" :key="item.id" :label="item.title.title" :value="item.title.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="学期" prop="semester">
        <el-select v-model="formInline.semester" clearable placeholder="请选择学期" :disabled="!formInline.schoolYear">
          <el-option v-for="item in yearSemesters" :key="item.id" :label="item.title" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form> -->
    <ming-table v-model="data" v-loading="loading" :fields="column">
      <!-- title -->
      <template #title="{ scope }">
        <span v-if="scope.homework.title">{{ scope.homework.title }}</span>
        <span v-else>-</span>
      </template>
      <template #week="{ scope }">
        <span v-if="scope.startWeek">{{ scope.startWeek }}&nbsp;~&nbsp;{{ scope.endWeek }}周</span>
        <span v-else>-</span>
      </template>
      <template #teacher="{ scope }">
        <span style="color: var(--theme-color); cursor: pointer" title="点击查看" @click="openTeacherDialog(scope.teachers)">{{ scope.teacher }}</span>
      </template>
      <template #start_time="{ scope }">
        开始： {{ moment(scope.homework.start_time * 1000).format('YYYY-MM-DD HH:mm') }} <br />
        结束：{{ moment(scope.homework.end_time * 1000).format('YYYY-MM-DD HH:mm') }}
      </template>
      <template #fileState="{ scope }">
        <template v-if="scope.homeworkScore.file">
          {{ scope.homeworkScore.file && scope.homeworkScore.file.length ? '已提交' : '未提交' }}
        </template>
        <template v-else>
          <template v-if="scope.homework.end_time * 1000 < Date.now()"> 已截止 </template>
          <template v-else-if="scope.homework.start_time * 1000 > Date.now()"> 未开始 </template>
        </template>
      </template>
      <template #score="{ scope }">
        {{ scope.homeworkScore.score || '--' }}
      </template>
      <template #note="{ scope }">
        <div style="white-space: pre">{{ scope.homeworkScore.note || '--' }}</div>
      </template>
      <template #options="{ scope }">
        <template v-if="scope.homework.end_time * 1000 < Date.now()">
          <el-button type="text" @click="handleOpen(scope)">查看</el-button>
        </template>
        <template v-else-if="scope.homework.start_time * 1000 > Date.now()">
          <el-button type="text" disabled>提交</el-button>
        </template>
        <template v-else>
          <el-button type="text" @click="handleOpen(scope)">{{ scope.homework_score_file && scope.homework_score_file.length ? '重新提交' : '提交' }}</el-button>
        </template>
      </template>
    </ming-table>

    <el-dialog
      :title="`提交作业【${courseInfo.courseName}】`"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleClose"
    >
      <template v-if="courseInfo && courseInfo.homework">
        <!-- {{ courseInfo }} -->
        <template v-if="courseInfo.homework.demand">
          <div>
            <strong>作业要求</strong>
          </div>
          <p style="white-space: pre-line; margin: 10px 0">
            {{ courseInfo.homework.demand }}
          </p>
        </template>

        <template v-if="courseInfo.homework.demand_file && courseInfo.homework.demand_file.length > 0">
          <p style="margin: 10px 0">
            <strong>作业要求附件</strong>
          </p>
          <p v-for="(item, index) in courseInfo.homework.demand_file" :key="index" style="margin: 10px 0">
            <a :href="BASE_URL + item.url" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; color: var(--theme-color)" :download="item.name"> {{ item.name }} </a>
          </p>
        </template>

        <!-- 作业上传 组件 -->
        <el-form v-if="dialogVisible" ref="fileFormRef" :key="fileForm.key" :model="fileForm" :rules="rules" class="demo-ruleForm" lable-position="top">
          <el-form-item prop="file">
            <upload-component
              :is-disabled="courseInfo.end_time * 1000 < Date.now()"
              :accept-type="courseInfo.homework.format?.map(el => `.${el}`).join(',')"
              button-text="上传作业"
              :file-list="fileForm.file"
              :limit-num="courseInfo.homework.max_upload_number"
              :extend-updata="extendUpdata"
            >
            </upload-component>
          </el-form-item>
        </el-form>
      </template>

      <span v-if="courseInfo.homework && courseInfo.homework.end_time * 1000 > Date.now()" slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取 消</el-button>
        <el-button type="primary" :loading="isSubmitLoading" @click="SubmitEvent()">确 定</el-button>
      </span><span v-else slot="footer" class="dialog-footer">
		<el-button @click="handleClose()">关闭</el-button></span>
    </el-dialog>

    <course-time-dialog v-if="CourseTimeVisible" :visible.sync="CourseTimeVisible" :type="CourseType" :teacher-data="teacherData" :course-id="CourseID" />
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader'
import { myHomeWork } from './tableColumn/index'
import { ref, onMounted } from 'vue'
import CourseTimeDialog from './components/CourseTimeDialog.vue'
import API from '@/api'
import Store from '@/store'
import UploadComponent from '@/components/UploadComponent'
import { Message } from 'element-ui'
import moment from 'moment'
const BASE_URL = process.env.VUE_APP_FILE_URL
const formInline = ref({
  semester: '',
  schoolYear: ''
})
const loading = ref(false)

// 学年下拉数据
// const schoolYearLists = computed(() => {
//   return Store.state.common.UserPortalData.schoolYearLists
// })

// const pageHeaderArr = ref([
//   {
//     title: '学年',
//     value: ''
//   },
//   {
//     title: '学期',
//     value: ''
//   },
//   {
//     title: '教学周',
//     value: ''
//   }
// ])

const column = ref(myHomeWork)
const data = ref([])
// 获取我的课表table数据
function getCourseTable(params) {
  loading.value = true
  API.myHomeworkList(params)
    .then(res => {
      if (+res.code === 200) {
        data.value = res.data.list || []
        loading.value = false
      } else {
        loading.value = false
      }
    })
    .catch(_ => {
      loading.value = false
    })
}

/* 获取当前学年、学期、周数 */
// function getSchoolCalendar() {
//   API.Semester().then(res => {
//     if (+res.code === 200) {
//       const { semester, schoolYear, week, school_year_id, id } = res.data
//       const data = [
//         {
//           title: '学年',
//           value: schoolYear || '-'
//         },
//         {
//           title: '学期',
//           value: semester || '-'
//         },
//         {
//           title: '教学周',
//           value: week ? `第${week}周` : '-'
//         }
//       ]
//       yearChangeSelect(school_year_id)
//       formInline.value.schoolYear = +school_year_id || ''
//       formInline.value.semester = +id || ''
//       pageHeaderArr.value = data
//       getCourseTable({ schoolYear: school_year_id, semester: id })
//     }
//   })
// }

const CourseTimeVisible = ref(false)
const CourseID = ref(null)
const CourseType = ref('')

const teacherData = ref([])

function openTeacherDialog(data) {
  CourseType.value = 'teacher'
  CourseTimeVisible.value = true
  teacherData.value = data
}

/* 搜索 */
// const onSubmit = () => {
//   getCourseTable(formInline.value)
// }
// /* 重置 */
// const reset = () => {
//   formInline.value = {
//     schoolYear: '',
//     semester: ''
//   }
//   getCourseTable(formInline.value)
// }

// const yearSemesters = ref([])
// const yearClearChange = function () {
//   nextTick(() => {
//     delete formInline.value.semester
//     yearSemesters.value.splice(0, yearSemesters.value.length)
//   })
//   yearChangeSelect()
// }
// // 学年change 获取学期
// function yearChangeSelect(schoolYear) {
//   getSchoolYearSemesters(schoolYear)
// }
// // 获取学期
// function getSchoolYearSemesters(schoolYear) {
//   API.schoolYearSemesters({ schoolYear }).then(res => {
//     if (res.code === 200) {
//       yearSemesters.value = res.data
//     }
//   })
// }
// 打开课程弹窗
const fileForm = ref({
  file: []
})
const rules = ref({
  file: [{ required: true, message: '请上传作业' }]
})

const dialogVisible = ref(false)

const handleClose = () => {
  if (isSubmitLoading.value) {
    Message.error('正在提交中，请稍后')
    return
  }
  fileFormRef.value.resetFields()
  dialogVisible.value = false
}
const isSubmitLoading = ref(false)
const fileFormRef = ref(null)
const SubmitEvent = () => {
  fileFormRef.value.key = +new Date()
  fileFormRef.value.validate(valid => {
    if (valid) {
      isSubmitLoading.value = true
      API.myHomeworkUpload({ ...fileForm.value, file: fileForm.value.file.map(el => ({ name: el.name, url: el.url })) })
        .then(res => {
          isSubmitLoading.value = false
          if (+res.code === 200) {
            handleClose()
            getCourseTable(formInline.value)
          } else {
            Message.error(res.msg)
          }
        })
        .catch(() => {
          isSubmitLoading.value = false
        })
    }
  })
}

const courseInfo = ref({})
const extendUpdata = ref({})
const handleOpen = row => {
  courseInfo.value = JSON.parse(JSON.stringify(row))
  fileForm.value.homework_id = row.homework.id
  fileForm.value.file = courseInfo.value.homeworkScore.file || []
  fileForm.value.key = Date.now()

  dialogVisible.value = true

  extendUpdata.value = {
    source: 'homework',
    source_id: row.homework.id
  }
}
onMounted(() => {
  // getSchoolCalendar()
  getCourseTable({ page: 1 })
  Store.dispatch('common/UserPortalData')
})
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

.my-schedule-table {
  margin-top: 20px;
}

.line {
  margin-top: 100px;
  position: relative;
  width: 100%;
  height: 1px;
  background-color: #000;

  &::before {
    content: attr(labelName);
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    width: auto;
    height: 20px;
    margin-top: -10px;
    padding-right: 20px;
    background-color: #fff;
  }
}

ul {
  margin: 0;
  padding: 0;
}

.table-head {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // background-color: #eee;
  border: 1px solid #dfe6ec;
  border-bottom: none;

  li {
    list-style: none;
    flex: 1;
    text-align: center;
    color: #333;
    padding: 12px 0;
    color: #909399;
    font-weight: bold;

    &:not(:last-child) {
      border-right: 1px solid #dfe6ec;
    }
  }
}

.table-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #dfe6ec;

  li {
    width: 100%;
    list-style: none;
    display: flex;
    justify-content: flex-start;

    &:not(&:first-child) {
      border-top: 1px solid #dfe6ec;
    }

    span {
      display: flex;
      flex: 1;
      padding: 10px 0;
      justify-content: center;
      align-items: center;
      padding: 10px 0;
      text-align: center;

      &:not(:last-child) {
        border-right: 1px solid #dfe6ec;
      }
    }
  }
}

.tips {
  padding: 20px 0;
  text-align: center;
  color: #ccc;
}
</style>
